// 用户相关模块

import axios from 'axios'
const state = {
    userInfo: JSON.parse(window.localStorage.getItem('userInfo')), //用户信息
    userToken: window.localStorage.getItem("userToken"), //用户token信息，用于判断登录用
}
const getters = {
    // 获取用户登录信息
    getUserInfo: (state) => (key = null) => {
        if (!state.userInfo) return null;
        // 如果未传键名，返回用户的所有信息，否则返回对应的信息
        if (!key) return state.userInfo;
        return state.userInfo[key];
    },
    isAdmin: (state) => state.userInfo && state.userInfo['userType'] == 'co',
    userInfo: (state) => state.userInfo || {},
    // 获取用户信息
    getUser: (state) => (key = null) => {
        // 如果未传键名，返回用户的所有信息，否则返回对应的信息
        if (!key) return state;
        return state[key];
    },
}
const mutations = {
    updateUser: (state, userObj) => {
        for(let key in userObj) {
            if (userObj[key]) {
                window.localStorage.setItem(key, userObj[key]);
            } else {
                window.localStorage.removeItem(key);
            }
            state[key] = userObj[key];
        }
    },
    updateUserInfo: (state, options) => {
        state.userInfo = {...options};
        window.localStorage.setItem("userInfo", JSON.stringify(options));
    }
}
const actions = {
    updateUser: ({commit}, options) => {
        commit('updateUser', options);
    },
    // 更新用户信息
    setUserInfo({commit}, options) {
        commit('updateUserInfo', options);
    },
    // 异步获取用户信息
    async updateUserInfo({commit}) {
        await axios.get("/api/user/login-info").then(({status, data}) => {
            if (status == 200 && data.status == 200) {
                commit('updateUserInfo', data.data);
            }
        })
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/User.js